module.exports = __webpack_public_path__ + "img/source_mg-sub.1efa5c4c.png";